import React, { Component } from "react";
import PropTypes from "prop-types";
import ComponentScroll from "./ComponentScroll";
import Notification from "./Notification";
import { withStylesAndTranslation } from "../utils/container";

const styleSheet = theme => ({});

class NotificationScroll extends Component {
    static propTypes = {
        hasMore: PropTypes.bool.isRequired,
        edges: PropTypes.object.isRequired,
        loadMore: PropTypes.func.isRequired,
        classes: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired,
        emptyStateMessage: PropTypes.string
    };

    renderer = node => {
        return <Notification notification={node} />;
    };

    render() {
        let { t, edges, loadMore, hasMore, emptyStateMessage } = this.props;

        if (!emptyStateMessage) {
            emptyStateMessage = t(
                "notificationScroll.There are no notifications to display"
            );
        }
        return (
            <ComponentScroll
                emptyStateMessage={emptyStateMessage}
                edges={edges}
                renderComponent={this.renderer}
                loadMore={loadMore}
                hasMore={hasMore}
            />
        );
    }
}
export default withStylesAndTranslation(NotificationScroll, styleSheet);



// WEBPACK FOOTER //
// ./src/components/NotificationScroll.jsx